"use client";
import React from "react";

const items = [
  "Gaming-PCs",
  "Kabelmanagement",
  "Windows-Setup",
  "RGB-Einrichtung",
  "BIOS-Update",
  "Gaming-Optimierung",
  "Premium-Builds",
  "Persönliche Beratung",
  "Faire Preise",
  "Schweiz",
];

export default function MarqueeStrip() {
  const doubled = [...items, ...items];
  return (
    <div className="w-full overflow-hidden border-y border-white/[0.06] bg-[#0A0A14] py-4 relative z-10">
      <div className="marquee-track">
        {doubled?.map((item, i) => (
          <span key={i} className="inline-flex items-center gap-6 px-6">
            <span className="font-display font-bold text-sm uppercase tracking-widest text-white/30">
              {item}
            </span>
            <span className="w-1 h-1 rounded-full bg-violet-500/60 flex-shrink-0" />
          </span>
        ))}
      </div>
    </div>
  );
}